import { createAction } from 'redux-actions';

export const REQUEST_CLUB = 'REQUEST_CLUB';
export const RECEIVE_CLUB = 'RECEIVE_CLUB';

export const REQUEST_CLUBS = 'REQUEST_CLUBS';
export const RECEIVE_CLUBS = 'RECEIVE_CLUBS';

export const REQUEST_SEARCH_CLUBS = 'REQUEST_SEARCH_CLUBS';
export const RECEIVE_SEARCH_CLUBS = 'RECEIVE_SEARCH_CLUBS';

export const REQUEST_ADVANCED_SEARCH_CLUBS = 'REQUEST_ADVANCED_SEARCH_CLUBS';
export const RECEIVE_ADVANCED_SEARCH_CLUBS = 'RECEIVE_ADVANCED_SEARCH_CLUBS';

export const requestClub = createAction(REQUEST_CLUB);
export const receiveClub = createAction(RECEIVE_CLUB);

export const requestClubs = createAction(REQUEST_CLUBS);
export const receiveClubs = createAction(RECEIVE_CLUBS);

export const requestSearchClubs = createAction(REQUEST_SEARCH_CLUBS);
export const receiveSearchClubs = createAction(RECEIVE_SEARCH_CLUBS);

export const requestAdvancedSearchClubs = createAction(
  REQUEST_ADVANCED_SEARCH_CLUBS
);
export const receiveAdvancedSearchClubs = createAction(
  RECEIVE_ADVANCED_SEARCH_CLUBS
);



// WEBPACK FOOTER //
// ./src/modules/club/actions.js